import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Codebook from './Codebook';
import ExcelReport from './ExcelReport';
import PresentationTheme from '../PresentationThemePage/PresentationTheme';
import PageHeader from '../../components/common/header/PageHeader';
import {loggedInUserSelector} from '../../../store/selectors/auth.selectors';
import {Role} from '../../../incase-domain/user';

function DashboardPage(): JSX.Element {
    const {t} = useTranslation();
    const loggedInUser = useSelector(loggedInUserSelector);
    const isSuperuser = loggedInUser?.roles?.includes(Role.SUPERUSER);

    return (
        <div className="l-container">
            <PageHeader title={t('navigation.dashboard')} />

            {isSuperuser && (
                <>
                    <div className="u-mb-3">
                        <ExcelReport />
                    </div>

                    <div className="u-mb-3">
                        <Codebook />
                    </div>
                </>
            )}

            <div className="u-mt-3">
                <PresentationTheme />
            </div>
        </div>
    );
}

export default DashboardPage;
